import {
  ACCOUNT_SWAP_FREE_ROUTE,
  ACCOUNTS_ROUTE,
  CREATE_ACCOUNT_ROUTE,
  KYC_ROUTE,
} from "_constants";
import { lazy } from "react";

const Accounts = lazy(() => import("pages/accounts"));
const KYC = lazy(() => import("pages/kyc"));
const CreateAccount = lazy(() => import("pages/accounts/create-account"));
const AccountSwapFree = lazy(() => import("pages/accounts/swap-free"));

export const accountRoutes = [
  { path: ACCOUNTS_ROUTE, element: <Accounts /> },
  { path: KYC_ROUTE, element: <KYC /> },
  { path: CREATE_ACCOUNT_ROUTE, element: <CreateAccount /> },
  {
    path: `${ACCOUNT_SWAP_FREE_ROUTE}/:loginSid`,
    element: <AccountSwapFree />,
  },
];
